import React from "react";
import { product } from "../data/product";
export function Footer() {
  return <footer className="bg-white px-4 py-8 sm:px-6" data-id="element-91" data-mp="3gezdb400vr15">
      <p className="mx-auto max-w-3xl text-center text-sm text-muted" data-id="element-92" data-mp="3ggtxgg3gzf46">
        © {new Date().getFullYear()} {product.name}. Tutti i diritti riservati.
      </p>
    </footer>;
}